<template>
  <div class="flex flex-col gap-4">
    <div class="p-4 bg-yellow-50 border border-yellow-200 rounded">
      <p class="text-yellow-800 font-semibold mb-2">Unknown Integration Type</p>
      <p class="text-sm text-yellow-700">
        This integration type "{{ integration.type }}" is not currently supported in the admin interface.
        The integration exists in the system but cannot be edited here.
      </p>
    </div>

    <div v-if="integration.id" class="text-gray-dark text-sm">
      <div><strong>ID:</strong> {{ integration.id }}</div>
      <div v-if="integration.channels && integration.channels.length > 0">
        <strong>Channels:</strong> {{ integration.channels.map(c => c.id || c.name).join(', ') }}
      </div>
    </div>

    <div class="text-sm text-gray-dark mt-4">
      <p>Raw integration data:</p>
      <pre class="mt-2 p-3 bg-gray-100 rounded text-xs overflow-auto max-h-60">{{ JSON.stringify(integration, null, 2) }}</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnknownIntegrationView',
  
  props: {
    integration: {
      type: Object,
      required: true
    }
  }
}
</script>

